<template>
  <v-container>
    <h2></h2>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <h4>Address Information</h4>
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Firstname:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.firstname || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Lastname:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.lastname || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Company name:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.company_name || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Company branch:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.company_branch || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Tax ID:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.tax_id || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Address detail:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_detail || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Sub-district:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_sub_district || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>District:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_district || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Province:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_province || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Country:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_country || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Postal code/zipcode:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.address_postal_code || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Phone number:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ address.phone_number || '-' }}</p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'address-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "AddressView",
  components: { },
  data: () => ({
    address_id: null,
    address: {
      firstname: null,
      lastname: null,
      company_name: null,
      company_branch: null,
      tax_id: null,
      address_detail: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_country: null,
      address_postal_code: null,
      phone_number: null
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    await this.getAddress(id)
  },
  methods: {
    async getAddress (id) {
      this.address_id = id
      try {
        const result = await this.$http.get(`/back-office/addresses/${this.address_id}`, authHeader())
        this.address.firstname = result.data.firstname
        this.address.lastname = result.data.lastname
        this.address.company_name = result.data.company_name
        this.address.company_branch = result.data.company_branch
        this.address.tax_id = result.data.tax_id
        this.address.address_detail = result.data.address_detail
        this.address.address_sub_district = result.data.address_sub_district
        this.address.address_district = result.data.address_district
        this.address.address_province = result.data.address_province
        this.address.address_country = result.data.address_country
        this.address.address_postal_code = result.data.address_postal_code
        this.address.phone_number = result.data.phone_number
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      return true
    }
  },
};
</script>
